module.exports = __webpack_public_path__ + "img/finacial-security.bca358a9.png";